import { BarChart3, Camera, FileText, LayoutDashboard, MapPin, Settings, Shield, Zap } from "lucide-react";

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  "/dashboard": LayoutDashboard,
  "/invoices": FileText,
  "/addresses": MapPin,
  "/actions": Zap,
  "/meter-readings": Camera,
  "/analytics": BarChart3,
  "/settings": Settings,
  "/admin/settings": Shield,
};

const sectionGroups = [
  { labelKey: "nav.main", links: ["/dashboard", "/invoices", "/addresses"] },
  { labelKey: "nav.tools", links: ["/actions", "/analytics", "/meter-readings", "/settings"] },
];

export { iconMap, sectionGroups };
